import React from 'react';

const PerfectionQuote = () => {
  return (
    <section className="perfection-quote-section">
      <div className="container">
        <div className="perfection-quote-container">
          <blockquote className="perfection-quote">
            <p>Si la perfección existe... se aproximaría con cada detalle añadido, convirtiéndose en una obra maestra de precisión y belleza.</p>
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default PerfectionQuote;
